import { createSlice } from "@reduxjs/toolkit";
import { createSize, ISize } from "../../../models/sizes";

interface ISizeState {
    sizes: ISize[],
    size: ISize,
    isLoading: boolean,
};

const initialState: ISizeState = {
    sizes: [],
    size: createSize({}),
    isLoading: false,
};

export const sizesSlice = createSlice({
    name: 'sizes',
    initialState,
    reducers: {
        setSizes: (state, action) => {
            state.isLoading = false;
            state.sizes = action.payload.sizes;
        },
        setSize: (state, action) => {
            state.isLoading = false;
            state.size = action.payload.size;
        },
        startLoadingSizes: (state) => {
            state.isLoading = true;
        }
    }
});

export const {
    setSizes,
    setSize,
    startLoadingSizes
} = sizesSlice.actions;